var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinanceCoinBnbLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95003 10.8336L11.3368 6.44674L15.7257 10.8355L18.2782 8.28298L11.3368 1.3418L4.39774 8.2809L6.95012 10.8334L6.95003 10.8336ZM0.0427246 12.6359L2.59529 10.083L5.14767 12.6354L2.5951 15.1879L0.0427246 12.6359ZM6.95003 14.4385L11.3368 18.8251L15.7256 14.4365L18.2795 16.9876L18.2782 16.9889L11.3368 23.93L4.39774 16.9909L4.39412 16.9873L6.9503 14.4383L6.95003 14.4385ZM17.526 12.637L20.0786 10.0844L22.631 12.6368L20.0785 15.1894L17.526 12.637Z",
    fill: "#F3BA2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9252 12.633H13.9262L11.3363 10.043L9.42199 11.9567L9.20207 12.1767L8.74849 12.6304L8.74487 12.6339L8.74849 12.6376L11.3363 15.2257L13.9264 12.6357L13.9277 12.6342L13.9253 12.633",
    fill: "#F3BA2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceCoinBnbLogo);
export default __webpack_public_path__ + "static/media/binance-coin-bnb-logo.a267b6adae3b12d145181001540518dc.svg";
export { ForwardRef as ReactComponent };